import { connect } from 'react-redux';
import Grid from '../components/portfolio/grid/grid';
import { getGridItems } from '../redux/actions/actions'

function mapStateToProps(state, ownProps) {
  return {
    gridItems: state.grid.gridItems
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onComponentMount: () => {
      dispatch(getGridItems())
    }
  }
}

const VisibleGrid = connect(
  mapStateToProps,
  mapDispatchToProps
)(Grid)

export default VisibleGrid;


// WEBPACK FOOTER //
// ./src/containers/visible-grid.js